import { useNavigate } from '@tanstack/react-router';

import { useEstimationQueryActions } from '@/api/hooks/estimationQueryActions';
import RoundArrowLeftIcon from '@/assets/round-arrow-left-icon.svg?react';
import { Button } from '@/components/atoms/Button';
import { useMessages } from '@/hooks/messages';

import { eEstimationDetailTab } from '../model';
import { estimationCancelReviewButtonMessageDefinitions } from './messages';

interface CancelReviewButtonProps {
  estimationId: string;
}

export const CancelReviewButton: FC<CancelReviewButtonProps> = ({ estimationId }) => {
  const messages = useMessages(estimationCancelReviewButtonMessageDefinitions);
  const navigate = useNavigate();

  const { useCancelEstimationReview } = useEstimationQueryActions();
  const reviewCancellationMutation = useCancelEstimationReview();

  return (
    <Button
      data-testid='cancel-review-button'
      variant='warning'
      outlined
      IconComponentLeft={RoundArrowLeftIcon}
      onClick={async () => {
        await reviewCancellationMutation.mutateAsync({ estimationId });
        await navigate({
          to: '/estimation/detail/$estimationId/$tabId',
          params: { estimationId, tabId: eEstimationDetailTab.estimation },
        });
      }}
    >
      {messages.cancelReviewButton()}
    </Button>
  );
};
